module.exports = __webpack_public_path__ + "static/img/lowest_bg.c3be06e4.png";